import {checkConditions} from "@/2_app-logic/utils/utils";

export function paginatorGetter(query) {
    if (checkConditions([query.response, query])) {
        return { ...query.paginator, ...query.response.data.paginator }
    }
}

export function timeGetter(query) {
    if (checkConditions([query.response])) {
        return query.response.data.time
    }
}

export function isAjaxReady() {
    return new Promise( resolve => {
        const timer = setInterval(() => {
            if (window._ajax) {
                clearInterval(timer)
                resolve(true)
            }
        }, 300)
    })
}